<template>
  <dialog-box
    :is-show="isShow"
    class="resraku"
    @input="$emit('close')" >
    <h1 class="resraku__heading">レスラクの在庫システムと在庫情報を連携中です。</h1>

    <p class="resraku__text">この画面の内容を変更すると、連携に不整合が生じる恐れがあります。<br>
      以下、項目を変更すると連携が解除されますので、ご注意ください。</p>

    <ul class="resraku__text">
      <li>・予約設定 &gt; 席登録：席の追加依頼は「レスラク」までお問合せください</li>
      <li>・予約設定 &gt; 予約基本情報設定：回転設定は「1組のみ」でお願いいたします</li>
      <li>・予約設定 &gt; 指定媒体予約連携：変更希望の場合は「Retty」までお問合せください</li>
    </ul>

    <div class="resraku__information">
      <p>レスラクへのお問い合わせ先<br>
        tel : <span class="resraku__tel">03-6721-0678</span><br>
        email : customer@resraku.jp
      </p>
    </div>

    <div class="resraku__buttons">
      <button-action
        :disabled="isProcessing"
        class="resraku__button-item resraku__button-item--close"
        title="閉じる"
        @click="$emit('close')"/>
      <button-action
        :disabled="isProcessing"
        class="resraku__button-item resraku__button-item--edit"
        title="編集する"
        is-primary
        @click="onEdit"/>
    </div>
  </dialog-box>
</template>

<script>
import DialogBox from '@/mikan/_shared/components/molecules/DialogBox.vue';
import ButtonAction from '@/mikan/_shared/components/atoms/ButtonAction.vue';

export default {
  components: {
    DialogBox,
    ButtonAction,
  },
  props: {
    editHref: {
      type: String,
      default: '',
    },
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isProcessing: false,
    };
  },
  methods: {
    onEdit() {
      this.isProcessing = true;
      location.href = this.editHref;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/mikan/_shared/base/constants';
@import '~@/mikan/_shared/base/mixins';

.resraku {
  font-size: 14px;

  &__heading {
    color: $color-strawberry;
    font-size: 22px;
    font-weight: bold;
    @include for-tb-pc {
      text-align: center;
    }
  }

  &__text {
    &:nth-child(n + 2) {
      margin-top: 20px;
    }
  }

  &__information {
    padding: 20px;
    border-top: 1px solid $color-navy-20;
    text-align: center;

    &:nth-child(n + 2) {
      margin-top: 20px;
    }
  }

  &__tel {
    font-size: 22px;
  }

  &__buttons {
    @include for-tb-pc {
      display: flex;
      justify-content: center;
    }
  }

  &__button-item {
    &--close {
      color: $color-navy-50;
    }

    &--edit {
      background-color: $color-strawberry;
    }

    @include for-tb-pc {
      width: 150px;
    }
    @include for-sp {
      display: block;
      width: 100%;
    }

    &:nth-child(n + 2) {
      @include for-tb-pc {
        margin-left: 12px;
      }
      @include for-sp {
        margin-top: 8px;
      }
    }
  }
}
</style>
